import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { Observable, of } from 'rxjs';
import { LeadAudit } from 'src/app/core/models/lead/lead-audit.model';
import { LeadInfoService } from '../services/lead-info.service';

@Component({
    selector: 'sidenav-content-lead-info-audits',
    templateUrl: './sidenav-content-lead-info-audits.component.html',
    styleUrls: ['./sidenav-content-lead-info-audits.component.scss'],
    standalone: false
})
export class SidenavContentLeadInfoAuditsComponent implements OnInit, AfterViewInit {

  @Input() set leadId(id: number) {
    this.audits$ = this.leadInfoService.getLeadAudit$(id)
    this.auditsCategories$ = this.leadInfoService.getAuditCategories$()
    this.categoryForm.valueChanges.subscribe(categories => this.selectedCategories = categories ?? [])
  }

  @ViewChild('auditSideNav') auditSidenav!: MatSidenav;

  audits$: Observable<LeadAudit[]> = of([])

  auditsCategories$: Observable<string[]> = of([])

  selectedAudit: LeadAudit | undefined = undefined
  selectedCategories: string[] = []

  categoryForm = new FormControl([]);

  auditDetailSidenavOpen: boolean = false

  constructor(private readonly leadInfoService: LeadInfoService,
    private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.auditSidenav.closedStart.subscribe(() => this.selectedAudit = undefined)
  }

  openAuditDetail(audit: LeadAudit) {
    this.selectedAudit = audit
    this.auditDetailSidenavOpen = true
  }

}
